import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <ol>
      <li parentName="ol">
        <p parentName="li">{`The PWA client uses the `}<a parentName="p" {...{
            "href": "/commerce/webapi/src/pages/graphql/schema/cart/mutations/set-payment-method.md"
          }}><inlineCode parentName="a">{`setPaymentMethodOnCart`}</inlineCode></a>{` mutation to set the payment method.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`The mutation returns a `}<inlineCode parentName="p">{`Cart`}</inlineCode>{` object.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`The client runs the `}<a parentName="p" {...{
            "href": "/commerce/webapi/src/pages/graphql/schema/cart/mutations/place-order.md"
          }}><inlineCode parentName="a">{`placeOrder`}</inlineCode></a>{` mutation, which creates an order and begins the authorization process.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`The application requests a secure token from the PayPal gateway.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`The gateway response includes a secure token, a secure token ID, and the URL to use for requesting the form in step 9. This token secures the data for a one-time transaction and is valid for 30 minutes.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`The `}<inlineCode parentName="p">{`placeOrder`}</inlineCode>{` mutation returns an order ID. The application does not return secure token information. The order has the status `}<inlineCode parentName="p">{`payment pending`}</inlineCode>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`The client runs the `}<a parentName="p" {...{
            "href": "/commerce/webapi/src/pages/graphql/schema/checkout/queries/get-payflow-link-token.md"
          }}><inlineCode parentName="a">{`getPayflowLinkToken`}</inlineCode></a>{` mutation to retrieve the secure token information.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`The application returns the token information.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`The client displays a payment form in an iframe rendered from the URL specified by the `}<inlineCode parentName="p">{`paypal_url`}</inlineCode>{` from the `}<inlineCode parentName="p">{`getPayflowLinkToken`}</inlineCode>{` mutation response. When the customer completes the form, the client sends the payment information directly to the PayPal gateway, bypassing the application server.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`After PayPal processes the payment, the gateway runs a silent post request against the application server. As a result, the application sets the order status to processing, and the order is ready to be invoiced.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`The PayPal gateway returns control of the customer's browser to the client.`}</p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      